module.exports = __webpack_public_path__ + "static/media/home-line.e3083b91.svg";